import axiosClient from "api/axiosClient";

export const verifyDodoPayment = async (paymentId: string) => {
  try {
    const response = await axiosClient.post("/api/orders/verify/dodo", {
      paymentId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
